import script from "./tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./tabs.vue?vue&type=script&setup=true&lang=ts"

import "./tabs.vue?vue&type=style&index=0&id=770cbb11&lang=css"

const __exports__ = script;

export default __exports__